// extracted by mini-css-extract-plugin
export default {"pageWrapper":"CommonContainer_pageWrapper__BPXYW"};